import React from 'react';

import { Box, Typography, Button, IconButton } from '@mui/material';

import { ReactComponent as CancelIconBlue } from '../../../common/assets/icons/cancel_icon_blue.svg';

type Props = {
  onFinalize: () => void;
  onClickClose: () => void;
};

const ConfirmFinalizePopup: React.FC<Props> = ({
  onFinalize,
  onClickClose,
}) => {
  return (
    <Box
      sx={{
        maxWidth: '575px',
        minHeight: '365px',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        flex: 1,
        borderRadius: '15px',
        padding: '30px',
        flexDirection: 'column',
      }}
    >
      <IconButton
        onClick={onClickClose}
        sx={{ alignSelf: 'flex-start', justifySelf: 'right' }}
      >
        <CancelIconBlue />
      </IconButton>
      <Typography
        sx={{
          alignSelf: 'center',
          whiteSpace: 'break-spaces',
          textAlign: 'center',
          my: '24px',
        }}
        color='text.primary'
        variant='h5'
      >
        Do you want to finalize the sheet details?
      </Typography>
      <Box
        sx={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          alignSelf: 'center',
          display: 'flex',
        }}
      >
        <Button
          onClick={onClickClose}
          disableElevation
          color='appGray2'
          variant='contained'
          sx={{
            borderRadius: '50px',
            width: '180px',
            height: '60px',
            marginRight: '15px',
          }}
        >
          <Typography color='white'>Cancel</Typography>
        </Button>
        <Button
          onClick={onFinalize}
          disableElevation
          color='primary'
          variant='contained'
          sx={{
            borderRadius: '50px',
            width: '180px',
            height: '60px',
          }}
        >
          <Typography color='white'>Finalize</Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default ConfirmFinalizePopup;
